<template>
    <div class="space-y-4">
      <p class="text-md font-semibold text-gray-800 dark:text-gray-100">Choose location</p>
      <UDivider class="border-gray-300 dark:border-gray-600" />
      <div class="overflow-y-auto max-h-[30rem] space-y-4">
        <div
          v-for="(item, index) in displayedLocations"
          :key="index"
          class="flex items-center justify-between p-2 border rounded-lg shadow-sm cursor-pointer"
          :class="{
            'bg-primeval-50 border-1 border-primeval-700 pointer-events-none': item.id === locationId && item.ukid == providerId,
            'bg-gray-50': item.id !== locationId
          }"
          @click="redirectLocation(item.id, item.ukid)"
          :disabled="item.id === locationId"
        >
        <span>
          {{ item.locality }}
          <span v-if="!String(item.distance).includes('NaN')"> | {{ item.distance }}</span>
        </span>
          <div class="inline-flex gap-2">
            <UBadge label="Open" class="bg-green-700 text-white" size="xs" v-if="item.isOpened"></UBadge>
            <UBadge label="Closed" color="black" size="sm" v-else></UBadge>
          </div>
        </div>
        <!-- Show more button if the number of locations exceeds the limit -->
        <div v-if="locationsData.length > displayedLocations.length" class="text-center">
          <button @click="showMore" class="text-blue-500">Show more locations</button>
        </div>
      </div>
    </div>
</template>
  
<script setup>
  import { ref, computed } from 'vue';
  
  const props = defineProps(['provider', 'data']);
  const route = useRoute();
  const providerId = route.params.id;
  const locationsData = props.data;
  console.log(locationsData)
  const locationId = route.query.loc_id ? ref(route.query.loc_id) : props.data?.[0].id;
  const displayLimit = ref(10);
  
  const displayedLocations = computed(() => {
    return locationsData.slice(0, displayLimit.value);
  });
  
  const showMore = () => {
    displayLimit.value += 5;
  };
  
  const redirectLocation = (id, ukid) => {
    window.location.replace(`/providers/${ukid}?loc_id=${id}`);
  };

</script>
  